import { Component } from '@angular/core';
import { NeighborhoodService } from '../../../../services/neighborhood.service';

@Component({
  selector: 'app-rules-page',
  templateUrl: './rules-page.component.html',
  styleUrl: './rules-page.component.scss'
})
export class RulesPageComponent {

  public residentRulesUpdateButtonEnabled: boolean = false;
  public guardRulesUpdateButtonEnabled: boolean = false;

  public showResidentRules: boolean = false;
  public showGuardRules: boolean = false;

  constructor(
    public neighborhoodService: NeighborhoodService
  ) {

  }

  /*
   ██████╗ ███╗   ██╗██████╗ ███████╗███████╗██╗██████╗ ███████╗███╗   ██╗████████╗██████╗ ██╗   ██╗██╗     ███████╗███████╗███████╗██╗██╗     ███████╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
  ██╔═══██╗████╗  ██║██╔══██╗██╔════╝██╔════╝██║██╔══██╗██╔════╝████╗  ██║╚══██╔══╝██╔══██╗██║   ██║██║     ██╔════╝██╔════╝██╔════╝██║██║     ██╔════╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
  ██║   ██║██╔██╗ ██║██████╔╝█████╗  ███████╗██║██║  ██║█████╗  ██╔██╗ ██║   ██║   ██████╔╝██║   ██║██║     █████╗  ███████╗█████╗  ██║██║     █████╗  ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗
  ██║   ██║██║╚██╗██║██╔══██╗██╔══╝  ╚════██║██║██║  ██║██╔══╝  ██║╚██╗██║   ██║   ██╔══██╗██║   ██║██║     ██╔══╝  ╚════██║██╔══╝  ██║██║     ██╔══╝  ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝
  ╚██████╔╝██║ ╚████║██║  ██║███████╗███████║██║██████╔╝███████╗██║ ╚████║   ██║   ██║  ██║╚██████╔╝███████╗███████╗███████║██║     ██║███████╗███████╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
   ╚═════╝ ╚═╝  ╚═══╝╚═╝  ╚═╝╚══════╝╚══════╝╚═╝╚═════╝ ╚══════╝╚═╝  ╚═══╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚══════╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝

  */
  async onResidentRulesFileChange(event: any) {
    console.log(event);

    const file = event.target.files[0];

    console.log(file);
    if (file.size <= 6 * 1024 * 1024) { // Check if file size is less than or equal to 6 MB
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const base64File = e.target.result;
        // this.uploadedFiles.push(base64File);
        console.log(base64File);
        
        this.neighborhoodService.currentNeighborhood!.residentRulesFile = base64File;
        this.residentRulesUpdateButtonEnabled = true;
        
      };
      reader.readAsDataURL(file);
    } else {
      // console.error(`Archivo ${file.name} es mayor a 6MB, favor de subir un archivo menor 6 MB.`);
      alert(`Archivo ${file.name} es mayor a 6MB, favor de subir un archivo menor 6 MB.`);
      // this.formAnnouncement.get('file')?.setValue(null);
      this.neighborhoodService.currentNeighborhood!.residentRulesFile = undefined;
      this.residentRulesUpdateButtonEnabled = false;
    }
    
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗██████╗ ███████╗███████╗██╗██████╗ ███████╗███╗   ██╗████████╗██████╗ ██╗   ██╗██╗     ███████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝██╔══██╗██╔════╝██╔════╝██║██╔══██╗██╔════╝████╗  ██║╚══██╔══╝██╔══██╗██║   ██║██║     ██╔════╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗  ██████╔╝█████╗  ███████╗██║██║  ██║█████╗  ██╔██╗ ██║   ██║   ██████╔╝██║   ██║██║     █████╗  ███████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝  ██╔══██╗██╔══╝  ╚════██║██║██║  ██║██╔══╝  ██║╚██╗██║   ██║   ██╔══██╗██║   ██║██║     ██╔══╝  ╚════██║
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗██║  ██║███████╗███████║██║██████╔╝███████╗██║ ╚████║   ██║   ██║  ██║╚██████╔╝███████╗███████╗███████║
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝╚══════╝╚═╝╚═════╝ ╚══════╝╚═╝  ╚═══╝   ╚═╝   ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚══════╝╚══════╝

  */
  async updateResidentRules() {
    const flag = await this.neighborhoodService.update();
    if (flag) {
      this.residentRulesUpdateButtonEnabled = false;
      this.neighborhoodService.currentNeighborhood!.residentRulesFile = undefined;
      this.showResidentRules = false;
    }
  }

  /*
   ██████╗ ███╗   ██╗ ██████╗ ██╗   ██╗ █████╗ ██████╗ ██████╗ ██████╗ ██╗   ██╗██╗     ███████╗███████╗███████╗██╗██╗     ███████╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
  ██╔═══██╗████╗  ██║██╔════╝ ██║   ██║██╔══██╗██╔══██╗██╔══██╗██╔══██╗██║   ██║██║     ██╔════╝██╔════╝██╔════╝██║██║     ██╔════╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
  ██║   ██║██╔██╗ ██║██║  ███╗██║   ██║███████║██████╔╝██║  ██║██████╔╝██║   ██║██║     █████╗  ███████╗█████╗  ██║██║     █████╗  ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗
  ██║   ██║██║╚██╗██║██║   ██║██║   ██║██╔══██║██╔══██╗██║  ██║██╔══██╗██║   ██║██║     ██╔══╝  ╚════██║██╔══╝  ██║██║     ██╔══╝  ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝
  ╚██████╔╝██║ ╚████║╚██████╔╝╚██████╔╝██║  ██║██║  ██║██████╔╝██║  ██║╚██████╔╝███████╗███████╗███████║██║     ██║███████╗███████╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
   ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝  ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚══════╝╚══════╝╚═╝     ╚═╝╚══════╝╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝

  */
  async onGuardRulesFileChange(event: any) {
    console.log(event);

    const file = event.target.files[0];

    console.log(file);
    if (file.size <= 6 * 1024 * 1024) { // Check if file size is less than or equal to 6 MB
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const base64File = e.target.result;
        // this.uploadedFiles.push(base64File);
        console.log(base64File);
        
        this.neighborhoodService.currentNeighborhood!.guardRulesFile = base64File;
        this.guardRulesUpdateButtonEnabled = true;
        
      };
      reader.readAsDataURL(file);
    } else {
      // console.error(`Archivo ${file.name} es mayor a 6MB, favor de subir un archivo menor 6 MB.`);
      alert(`Archivo ${file.name} es mayor a 6MB, favor de subir un archivo menor 6 MB.`);
      // this.formAnnouncement.get('file')?.setValue(null);
      this.neighborhoodService.currentNeighborhood!.guardRulesFile = undefined;
      this.guardRulesUpdateButtonEnabled = false;
    }
    
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗ ██████╗ ██╗   ██╗ █████╗ ██████╗ ██████╗ ██████╗ ██╗   ██╗██╗     ███████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝██╔════╝ ██║   ██║██╔══██╗██╔══██╗██╔══██╗██╔══██╗██║   ██║██║     ██╔════╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗  ██║  ███╗██║   ██║███████║██████╔╝██║  ██║██████╔╝██║   ██║██║     █████╗  ███████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝  ██║   ██║██║   ██║██╔══██║██╔══██╗██║  ██║██╔══██╗██║   ██║██║     ██╔══╝  ╚════██║
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗╚██████╔╝╚██████╔╝██║  ██║██║  ██║██████╔╝██║  ██║╚██████╔╝███████╗███████╗███████║
   ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝ ╚═════╝  ╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚══════╝╚══════╝

  */
  async updateGuardRules() {
    const flag = await this.neighborhoodService.update();
    if (flag) {
      this.guardRulesUpdateButtonEnabled = false;
      this.neighborhoodService.currentNeighborhood!.guardRulesFile = undefined;
      this.showGuardRules = false;
    }
  }

}
